import React, { Component } from "react";
import { Dropdown, MenuItem, DropdownButton } from "react-bootstrap";
import { MessageType } from "../../../Constant";
import PropTypes from "prop-types";
import './dropdown.css'

class DropdownWrapper extends Component {

    constructor(props) {
        super(props);
    }
    render() {

        return (
            <div className="dropDown-wrapper" >
               
                <DropdownButton id="dropdown-basic-button" title={this.props.title} className="dropdown-button" disabled={this.props.disabled}bsPrefix="confirm-btn" >
                    {this.props.menue && this.props.menue.map((item, index) => (
                    <Dropdown.Item key={item.key} eventKey={item.key} onClick={() => this.props.onSelect(item.key)}>{item.value}</Dropdown.Item>
                    ))}
                </DropdownButton>
            </div>
        );
    }

}
DropdownWrapper.propTypes = {
  title: PropTypes.any,
  menue: PropTypes.array,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default DropdownWrapper;


